const locale = 'en-US';

export function formatLocale(value: number | bigint): string {
  if (typeof value === 'number' || typeof value === 'bigint')
    return value.toLocaleString(locale, { style: 'currency', currency: 'USD' });
  return '';
}
